import axios from 'axios';

import values from '../../constants/values';

const apiInstance = axios.create({
    baseURL: values.BASE_URL,
    timeout: 12000,
});
const B_Token = localStorage.getItem('B_Token')
const brokerapiInstance = axios.create({

    baseURL: `${process.env.REACT_APP_API_SILHOUTE_URL}`,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Token: B_Token,
    },
    timeout: 12000,
});

//Setting authentication token for logged In user
function setAuthToken(token) {
    apiInstance.defaults.headers.Token = token;

}

function setHeaderRefreshToken(token) {
    apiInstance.defaults.headers.Token = token;

}

//Removing authentication token for logged out user
function removeAuthToken() {
    delete apiInstance.defaults.headers.Authorization;
}

async function apiCall(url, method, { data, params },
) {
    // let compUrl = `${url}${connector ? '/' + connector + '/' : ''}`;
    params = params ? params : {};
    try {
        return await apiInstance.request({ url, method, data, params });
    } catch (error) {
        // console.log('API ERROR', error.response);
        if (error && error.response && error.response.data) {
            const responseData = error.response.data;
            if (typeof responseData === 'string') {
                return Promise.reject({
                    message: responseData,
                    status: error.response.status,
                });
            }
            if (typeof responseData === 'object') {
                return Promise.reject({
                    ...responseData,
                    status: error.response.status,
                });
            }
            return Promise.reject(responseData);
        }

        return Promise.reject('Request Time Out.');
    }
}
async function brokerapiCall(url, method, { data, params },
) {
    // let compUrl = `${url}${connector ? '/' + connector + '/' : ''}`;
    params = params ? params : {};
    try {
        return await brokerapiInstance.request({ url, method, data, params });
    } catch (error) {
        // console.log('API ERROR', error.response);
        if (error && error.response && error.response.data) {
            return Promise.reject(error.response.data);
        }

        return Promise.reject('Request Time Out.');
    }
}

export { apiCall, removeAuthToken, setAuthToken, setHeaderRefreshToken, brokerapiCall };
